export const PlatformsIcons = {
  1: 'apple',
  3: 'android',
  7: 'macos',
  8: 'windows',
  9: 'amazon',
  10: 'safari',
  11: 'chrome',
  12: 'firefox',
  13: 'edge',
  14: 'email',
  16: 'baidu',
  17: 'huawei',
  18: 'sms',
  19: 'xiaomi',
  21: 'whatsapp'
};
export const PlatformsLabels = {
  1: 'iOS',
  3: 'Android',
  7: 'macOS',
  8: 'Windows',
  9: 'Amazon',
  10: 'Safari',
  11: 'Chrome',
  12: 'Firefox',
  13: 'Internet Explorer',
  14: 'Email',
  16: 'Baidu',
  17: 'Huawei',
  18: 'SMS',
  19: 'Xiaomi',
  21: 'WhatsApp'
};
export var AllPlatforms;
(function (AllPlatforms) {
  AllPlatforms[AllPlatforms["IOS"] = 1] = "IOS";
  AllPlatforms[AllPlatforms["Blackberry"] = 2] = "Blackberry";
  AllPlatforms[AllPlatforms["Android"] = 3] = "Android";
  AllPlatforms[AllPlatforms["Asha"] = 4] = "Asha";
  AllPlatforms[AllPlatforms["WindowsPhone"] = 5] = "WindowsPhone";
  AllPlatforms[AllPlatforms["Bada"] = 6] = "Bada";
  AllPlatforms[AllPlatforms["OSX"] = 7] = "OSX";
  AllPlatforms[AllPlatforms["Windows"] = 8] = "Windows";
  AllPlatforms[AllPlatforms["Amazon"] = 9] = "Amazon";
  AllPlatforms[AllPlatforms["Safari"] = 10] = "Safari";
  AllPlatforms[AllPlatforms["Chrome"] = 11] = "Chrome";
  AllPlatforms[AllPlatforms["Firefox"] = 12] = "Firefox";
  AllPlatforms[AllPlatforms["IE"] = 13] = "IE";
  AllPlatforms[AllPlatforms["Email"] = 14] = "Email";
  AllPlatforms[AllPlatforms["FBMessenger"] = 15] = "FBMessenger";
  AllPlatforms[AllPlatforms["BaiduAndroid"] = 16] = "BaiduAndroid";
  AllPlatforms[AllPlatforms["HuaweiAndroid"] = 17] = "HuaweiAndroid";
  AllPlatforms[AllPlatforms["SMS"] = 18] = "SMS";
  AllPlatforms[AllPlatforms["Xiaomi"] = 19] = "Xiaomi";
  AllPlatforms[AllPlatforms["Web"] = 20] = "Web";
  AllPlatforms[AllPlatforms["WhatsApp"] = 21] = "WhatsApp";
})(AllPlatforms || (AllPlatforms = {}));